module.exports = __webpack_public_path__ + "static/media/no_more_bets.d252fec4.mp3";